module.exports = __webpack_public_path__ + "media/assets/icons/people-8da02123971b45a181e6b5c44fea2cf9.svg";